
























































































































































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';
import { systemSettingsMixin } from '@/mixins/systemSettings';

import { GlobalSystemSetting } from '@/models/setting/GlobalSystemSetting';
import { AccountSystemSetting } from '@/models/setting/AccountSystemSetting';
import { UserSystemSetting } from '@/models/setting/UserSystemSetting';
import { SystemUserSystemSetting } from '@/models/setting/SystemUserSystemSetting';

export default Vue.extend<any, any, any, any>({
  mixins: [
    iconsMixin,
    breakpointsMixin,
    authMixin,
    formatMixin,
    systemSettingsMixin,
  ],
  data() {
    return {
      currentTab: null,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      editing: false,
      showFilters: false,
      displayEditSettingPopup: false,
      displayCopySettingPopup: false,
      availableTabs: [
        'Application Settings',
        'Client Account Settings',
        'Client Employee Account Settings',
        'AFS TMS Employee Settings',
      ],
      snackbar: false,
      snackbarText: '',
      globalSystemSettings: [] as GlobalSystemSetting[],
      accountSystemSettings: [] as AccountSystemSetting[],
      userSystemSettings: [] as UserSystemSetting[],
      systemUserSystemSettings: [] as SystemUserSystemSetting[],
      key: null,
      value: null,
      description: null,
      clientName: null,
      userName: null,
      login: null,
      pagingRenderIndex: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.currentTab = this.getTabFromRoute();
      this.tabClicked(this.currentTab);
    },
    getTabFromRoute() {
      const routeParam = this.$route.path.split('/').pop();
      const tabMapping = {
        global: 'Application Settings',
        account: 'Client Account Settings',
        user: 'Client Employee Account Settings',
        employee: 'AFS TMS Employee Settings',
      };
      return tabMapping[routeParam] || 'Application Settings';
    },
    getRouteFromTab(tab) {
      const routeMapping = {
        'Application Settings': 'global',
        'Client Account Settings': 'account',
        'Client Employee Account Settings': 'user',
        'AFS TMS Employee Settings': 'employee',
      };
      return routeMapping[tab] || 'global';
    },
    showHideFilters() {
      this.showFilters = !this.showFilters;
    },
    showEditDialog(setting) {
      this.$store.commit('systemSettings/setCurrentTab', this.currentTab);
      this.$store.commit('systemSettings/setSystemSettingToEdit', setting);
      this.displayEditSettingPopup = true;
    },
    showCopyDialog(setting) {
      this.$store.commit('systemSettings/setCurrentTab', this.currentTab);
      this.$store.commit('systemSettings/setSystemSettingToCopy', setting);
      this.displayCopySettingPopup = true;
    },
    settingSaved() {
      this.snackbarText = 'Setting updated.';
      this.snackbar = true;
    },
    settingCopied() {
      this.snackbarText = 'Setting created.';
      this.snackbar = true;
    },
  },
  computed: {
    systemSettingToEdit() {
      return this.$store.getters['systemSettings/settingToEdit'];
    },
    currentlyEditingKey() {
      return this.$store.getters['systemSettings/currentlyEditingSettingKey'];
    },
  },
  watch: {
    $route() {
      // handle route changes (browser back/forward, direct URL access)
      const newTab = this.getTabFromRoute();
      if (this.currentTab !== newTab) {
        this.currentTab = newTab;
        this.tabClicked(newTab);
      }
    },
    key() {
      this.filter();
    },
    value() {
      this.filter();
    },
    description() {
      this.filter();
    },
    clientName() {
      this.filter();
    },
    userName() {
      this.filter();
    },
    login() {
      this.filter();
    },
  },
});
